import React, { Component } from 'react';
import { Container, Row, Col } from 'reactstrap';
import Notification from '../Notification/Notification';
import FontAwesome from 'react-fontawesome';
import FileUpload from '../FileUpload/FileUpload';
import ModUpload from '../../ModUpload';

class Step8 extends Component{

    constructor(props) {
        super(props);
        this.state = {
            baseUrl: window.location.hostname === 'localhost' ? 'http://apps/ReliabilityCheck' : process.env.PUBLIC_URL,
            showEmptyForms: true,
            data: null,
            intervalId: null,
            inProcess: false,
            needUpdate: false,
            message: "",
            success: true
        };
        this.checkStatus = this.checkStatus.bind(this);
        this.downloadFile= this.downloadFile.bind(this);
    }

    componentDidMount(){
        this.loadData();
    }

    componentDidUpdate(){
        //debugger;
        if(this.state.needUpdate && !this.state.inProcess){
            this.loadData();
            this.setState({ needUpdate: false })
        }
    }

    componentWillUnmount()
    {
        clearInterval(this.state.intervalId)
    }

    checkStatusNeeded(attachments){
        if(attachments !== null){
            let fileInProcess = null;
            let fileInProcessArr = attachments.filter(function(element){//.find((element) => {
                return element.Status === 0;
            });
            if(fileInProcessArr.length > 0){
                fileInProcess = fileInProcessArr[0];
            }
            if(fileInProcess !== null && this.state.intervalId === null){
                let intervalId = setInterval(() => this.checkStatus(), 5000);
                this.setState({intervalId: intervalId})
            }
        }
    }

    checkStatus(){
        let uploadLogic = new ModUpload();
        uploadLogic.getAttachmentsData(this.props.candidate.authKey, (res) => {
            if(res.data !== null && res.data.Attchments !== null){
                let fileInProcess = null;
                let fileInProcessArr = res.data.Attachments.filter(function(element){ //find
                    return element.Status === 0;
                });
                if(fileInProcessArr.length > 0){
                    fileInProcess = fileInProcessArr[0];
                }
                if(fileInProcess === null){
                    clearInterval(this.state.intervalId)
                }
            }
            this.setState({data: res.data});
        });
    }

    loadData(text){
        //debugger;
        //console.log("load data")
        let uploadLogic = new ModUpload();
        this.setState({inProcess: true});
        uploadLogic.getAttachmentsData(this.props.candidate.authKey, (res) =>{
            if(res.success){
                this.setState({data: res.data});
                this.setState({inProcess: false});
                this.checkStatusNeeded(this.state.data.Attachments);
            }
            else(
                this.setState({
                    message: res.message, 
                    success: false
                })
            )
        });
        
    }

    uploadFile(files){
        let modUploader = new ModUpload(this.state.data, this.props.candidate.authKey);
        
        modUploader.uploadFileService(files, (res) => {
            if(res.status === "success"){
                this.setState({ needUpdate: true });
            }
            else{
                this.setState({
                    message: res.message, 
                    success: false
                });
            }
        });
    }

    deleteFile(id){
        let modUploader = new ModUpload(this.state.data, this.props.candidate.authKey);
        
        modUploader.deleteFileService(id, (res) => {
            if(res.status === "success"){
                this.setState({
                    needUpdate: true,
                    message: "הקובץ נמחק בהצלחה",
                    success: true
                });
            }
            else{
                this.setState({
                    message: res.message, 
                    success: false
                });
            }
        });
    }

    downloadFile(id){
         let uploadLogic = new ModUpload();
         uploadLogic.downloadFileService(this.props.candidate.authKey, id, (res) => {
             if(res.status === 200){
                 const downloadUrl = window.URL.createObjectURL(new Blob([res.data]));
                 const link = document.createElement('a');
                 link.href = downloadUrl;
                 let fileName = "file.pdf"
                 var splited = res.headers["content-disposition"].split('=');
                 if(splited !== null && splited.length === 2){
                     fileName = splited[1];
                 }
                 link.setAttribute('download',fileName);
                 document.body.appendChild(link);
                 link.click();
                 link.remove();
                 this.setState({
                    message: "הקובץ ירד בהצלחה.", 
                    success: true
                })
             }
             else{
                this.setState({
                    message: "ארעה שגיאה בהורדת הקובץ נסה שנית.", 
                    success: false
                });
             }
         })
     }

    render(){
        
        if(this.state.data !== null){
            let mimeTypes = ""
            this.state.data.MimeTypes.map(m => {
                mimeTypes += m.replace(".", ", ");
            });
            mimeTypes = mimeTypes.substring(2, mimeTypes.length)
            return (
                <div>
                    <h2>העלאת קבצים</h2>

                    <div style={{marginBottom:'2rem'}}>
                        כעת, כשכל הפרטים האישיים נמצאים במערכת, כל מה שנשאר לעשות זה לחתום.<br/>
                        לנוחיותך, תוכל להוריד את כל הטפסים מאוגדים לקובץ אחד, כאשר פרטי המועמד מוטבעים בפנים <a style={{fontWeight:'bold'}} href={this.state.baseUrl + "/Attachment/DownloadFilledForms?authKey=" + this.props.candidate.authKey} target="_blank">בלינק הזה.</a> <br/>
                        לאחר שתחתום על הכל, יש לסרוק את הטפסים למחשב על ידי סורק או על ידי צילום הטפסים בטלפון הסלולרי (מומלץ להשתמש באפליקציה מתאימה) ולהעלות את הקבצים למערכת.<br/>
                        שים לב שיש להעלות כל טופס לחוד, לפי הסוג. כמו כן יש להעלות צילום תעודת זהות (כרטיס וספח).<br/>
                        ניתן להעלות קבצים עם סיומת: {mimeTypes}.<br/>
                        סך גודל כל הקבצים לא יעלה על: {(this.state.data.TotalSizeAllowed / 1024).toFixed(0) + "MB"}.

                    </div>
                    <div className="card" className="d-none d-md-block"  style={{marginBottom:'20px'}}>
                        <div className="card-body" style={{lineHeight:'2.5'}}>
                            <div className="row" style={{lineHeight: 1}}>
                                <div className="col col-lg-3">סוג</div>
                                <div className="col col-lg-3">שם</div>
                                <div className="col col-lg-2">סטטוס</div>
                                <div className="col col-lg-1">גודל MB</div>
                                <div className="col col-lg-2">תאריך העלאה</div>
                                <div className="col col-lg-1">פעולות</div>
                            </div>
                        </div>
                    </div>

                    {this.state.data.RequestedFiles.map(a => 
                        <FileUpload key={a.NameEng} fileData={a} uploadData={this.state.data} 
                                    required={true}
                                    uploadAction={(files) => this.uploadFile(files)} 
                                    deleteAction={(id) => this.deleteFile(id)} 
                                    downloadAction={(id) => this.downloadFile(id)}/>
                    )}
                    {this.state.data.OptionalFiles.map(a =>
                        <FileUpload key={a.NameEng} fileData={a} uploadData={this.state.data} 
                                    required={false}
                                    uploadAction={(files) => this.uploadFile(files)} 
                                    deleteAction={(id) => this.deleteFile(id)} 
                                    downloadAction={(id) => this.downloadFile(id)}/>
                    )}
                    <Notification success={this.state.success} message={this.state.message}/>
                    
                </div>
            );
        }
        else{
            return (<Container><Row><Col>פרטי הצרופות לבקשה זו יטענו בקרוב</Col></Row></Container>)
        }
    }
  };
  
  export default Step8;